import { render, staticRenderFns } from "./LicenseTab.vue?vue&type=template&id=45f938bd&scoped=true"
import script from "./LicenseTab.vue?vue&type=script&lang=js"
export * from "./LicenseTab.vue?vue&type=script&lang=js"
import style0 from "./LicenseTab.vue?vue&type=style&index=0&id=45f938bd&prod&lang=css"
import style1 from "./LicenseTab.vue?vue&type=style&index=1&id=45f938bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f938bd",
  null
  
)

export default component.exports